module.exports = __webpack_public_path__ + "assets/img/hand.77667a6a.svg";